export default "__VITE_ASSET__d68c76b2__"